import { useQuery } from '@tanstack/react-query'
import { currentQueryService } from 'utils/api/queries'

const useGetHolidays = () => {
  const query = useQuery<unknown, Error>({
    queryKey: ['useGetHolidays'],
    queryFn: () => currentQueryService.getHolidays(),
  })

  return query
}

export { useGetHolidays }
